// -------------------------------
// TEXTUAL EXPORTS

// Display to the console
module.exports.console = {
  START_MESSAGE_DEV: `Optiii Development Environment`,
  START_MESSAGE_PROD: `optiii.com.au © Dylan Carter`
}


// Display to the console
module.exports.tabbar = {
  GENERAL: `Optiii`
}

// Throughout application
module.exports.app = {
  TITLE_LOGIN: `Login`,
  TITLE_JOIN: `Get started`
}